import { ReactNode } from "react";
import { useQuestionizerStore, ValidationEntry } from "../types/state.ts";

export default function Input<T> (props: {title?: string, error_override?: ValidationEntry, id: number, required: boolean, value: T | undefined, type: "text" | "number", onChange: (value: T) => void, label: string, onBlur: ()=>void, children?: ReactNode}){
  const validation_inputs = useQuestionizerStore((state) => state.validation_inputs);
  const error = props.error_override || validation_inputs[props.id];
  const has_error = props.error_override || error !== undefined && !error.valid;

  const escaped_label = props.label.replaceAll("&shy;","");
  return <>
    <label id={"text-input-label-"+props.id} className={"text-input__label " + (props.value as string != "" ? "text-input__has_content" : "") } dangerouslySetInnerHTML={{__html: props.label}}></label>
    <div className={"text-input"}>
      <input 
      title={props.title}
      aria-invalid={has_error}
      aria-labelledby={"text-input-label-"+props.id}
      aria-describedby={"email-error-"+props.id}
      required={props.required} 
      tabIndex={0} 
      onBlur={props.onBlur}
      className={"text-input__input"} 
      aria-placeholder={escaped_label} 
      placeholder={escaped_label} type={props.type} value={props.value as string || ""} onChange={(value) => props.onChange(value.target.value as T) }/>
      {props.children}
    </div>
    <span className={"input__error"} id={"email-error-"+props.id} role="alert" style={{display: has_error ? "block" : "none"}}>{error ? error.message : ''}</span>
  </>
}